import React, { memo } from 'react';

const SvgNoCabinLuggage = () => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x={3.5} y={8.5} width={17} height={13} rx={1.5} stroke="#17181A" />
    <path d="M17 9c0-2.21-2.239-4-5-4S7 6.79 7 9" stroke="#17181A" />
    <path d="m16.043 11.067-8.067 8.067m0-8.067 8.067 8.067" stroke="#000" />
  </svg>
);

const Memo = memo(SvgNoCabinLuggage);
export default Memo;
